import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import Dropzone from 'react-dropzone-uploader';
import { getSettings, updateSettings } from '../../store/settingsSlice';

const PopupModalTable = () => {
  const storeVar = useSelector(state => state.settings);
  const dispatch = useDispatch();

  const [submit, setSubmit] = useState(false);
  const [bannerFile, setBannerFile] = useState(null);
  const [formVar, setFormVar] = useState({
    popupLink: '',
    popupEnabled: false,
    popupImage: '',
  });

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    if (storeVar?.settingsData) {
      const data = storeVar.settingsData;
      setFormVar({
        popupLink: data.popupLink || '',
        popupEnabled: !!data.popupEnabled,
        popupImage: data.popupImage || '',
      });
    }
  }, [storeVar?.settingsData]);

  const handleChangeStatus = ({ file }, status) => {
    if (status === 'done') {
      setBannerFile(file);
    }
    if (status === 'removed') {
      setBannerFile(null);
    }
  };

  const submitPopup = () => {
    setSubmit(true);
    const formData = new FormData();
    formData.append('popupLink', formVar.popupLink);
    formData.append('popupEnabled', formVar.popupEnabled);
    if (bannerFile) {
      formData.append('popupImage', bannerFile);
    }
    dispatch(updateSettings(formData));
  };

  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <CardHeader>
            <h5>Manage Home Popup Modal</h5>
            <Row className="mt-3">
              <Col md="12">
                <FormGroup className="d-flex align-items-center gap-3">
                  <Label className="col-form-label mb-0 font-weight-bold" for="popupEnabledToggle">
                    Enable Popup Modal on Website
                  </Label>
                  <div className="media-body text-end icon-state switch-outline">
                    <label className="switch mb-0">
                      <Input
                        type="checkbox"
                        id="popupEnabledToggle"
                        checked={formVar.popupEnabled}
                        onChange={(e) => setFormVar((prev) => ({ ...prev, popupEnabled: e.target.checked }))}
                      />
                      <span className="switch-state bg-primary"></span>
                    </label>
                  </div>
                </FormGroup>

                <FormGroup>
                  <Label className="col-form-label" for="popupLinkInput">Target Link / URL (Optional)</Label>
                  <Input
                    className="form-control"
                    type="text"
                    id="popupLinkInput"
                    placeholder="Enter Popup Redirect Link (e.g. /exam/123/live-class or https://...)"
                    value={formVar.popupLink}
                    onChange={(e) => setFormVar((prev) => ({ ...prev, popupLink: e.target.value }))}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="col-form-label">Popup Banner Image</Label>
                  {formVar.popupImage && !bannerFile && (
                    <div className="mb-3">
                      <p className="text-muted text-xs mb-1">Current Image:</p>
                      <img
                        src={formVar.popupImage}
                        alt="Current Popup"
                        style={{ maxHeight: '180px', borderRadius: '8px', objectFit: 'cover' }}
                      />
                    </div>
                  )}
                  <Dropzone
                    className="dropzone dz-clickable"
                    onChangeStatus={handleChangeStatus}
                    maxFiles={1}
                    multiple={false}
                    accept="image/*"
                    inputContent="Drop or Upload New Popup Image"
                    styles={{
                      dropzone: { width: '100%', height: 160 },
                      dropzoneActive: { borderColor: 'green' },
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <ModalFooter style={{ justifyContent: 'center' }}>
              <Btn attrBtn={{ color: 'primary', onClick: submitPopup }}>Save Popup Settings</Btn>
            </ModalFooter>
          </CardHeader>
        </Card>
      </Col>
    </Fragment>
  );
};

export default PopupModalTable;
